export default "__VITE_ASSET__f92a1413__"